import type { AiSuggestionInteractionPoint } from '@atlaskit/editor-common/analytics';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { addDiscardSuggestionAnalytics } from '../ui/utils/analytics';
import { updateSuggestionStatus } from '../ui/utils/api';

import type { DiscardSuggestionAction } from './types';

export const discardSuggestionAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => DiscardSuggestionAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id: string, interactionPoint: AiSuggestionInteractionPoint = 'sidebar'): boolean => {
		let found = false;
		api?.core?.actions.execute(({ tr }) => {
			const pluginState = api?.aiSuggestions?.sharedState.currentState();
			const suggestion = pluginState?.suggestionById.get(id);
			if (!suggestion) {
				return tr;
			}
			found = true;
			addDiscardSuggestionAnalytics(api?.analytics?.actions)(tr, suggestion, interactionPoint);
			tr.setMeta(aiSuggestionsPluginKey, { action: 'REMOVE_SUGGESTION', id });
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});

		if (found) {
			updateSuggestionStatus({ updates: [{ id, status: 'DISMISSED' }] });
		}

		return found;
	};
